import { render, staticRenderFns } from "./InisiasiLaporanPage.vue?vue&type=template&id=6801fa9b"
import script from "./InisiasiLaporanPage.vue?vue&type=script&lang=js"
export * from "./InisiasiLaporanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports